<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="8">
          <div class="page-title">答題記錄</div>
        </el-col>
      </el-row>
      <div class="page-content">
        <div class="page-box">
          <div class="page-content-row">
            <div >
              <el-input
                v-model="listQuery.userNoLike"
                placeholder="搜尋學生帳號"
              ></el-input>
            </div>
            <div v-if="userInfoRoleRoleId == siteAdminRoleId">
              <el-select
                v-model="listQuery.branchSchoolId"
                clearable
                placeholder="請選擇分校"
              >
                <el-option
                  v-for="(item, index) in $store.getters.branchSchools"
                  :key="index"
                  :label="item.abbreviation"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <el-select v-model="listQuery.gradeId" clearable placeholder="全部年級">
                <el-option
                  v-for="(item, index) in $store.getters.grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <el-select v-model="listQuery.objectType" clearable placeholder="全部模式" style="width: 100%">
                <el-option label="圖書館/冒險" value="0">圖書館/冒險</el-option>
                <el-option label="小測" value="1">小測</el-option>
                <el-option label="評估" value="2">評估</el-option>
                <el-option label="作業" value="3">作業</el-option>
              </el-select>
            </div>
            <div >
              <el-button size="mini" type="info" class="button-el-el" @click.native="onSearch">搜尋</el-button>
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column label="年級" min-width="30">
            <template slot-scope="{ row }">
              <span v-if="row.gradeId==1">小一</span>
              <span v-if="row.gradeId==2">小二</span>
              <span v-if="row.gradeId==3">小三</span>
              <span v-if="row.gradeId==4">小四</span>
              <span v-if="row.gradeId==5">小五</span>
              <span v-if="row.gradeId==6">小六</span>
            </template>
          </el-table-column>
          <el-table-column label="模式" min-width="50">
            <template slot-scope="{ row }">
              <span v-if="row.objectType==0">圖書館/冒險</span>
              <span v-if="row.objectType==1">小測</span>
              <span v-if="row.objectType==2">評估</span>
              <span v-if="row.objectType==3">作業</span>
            </template>
          </el-table-column>
          <el-table-column prop="topicName" label="課題名稱" min-width="100">
          </el-table-column>
          <el-table-column prop="objectName" label="練習名稱" min-width="100">
          </el-table-column>
          <el-table-column prop="userNo" label="學生帳號" min-width="50">
          </el-table-column>
          <el-table-column
              prop="startTime"
              label="開始時間"
              width="100"
              :formatter="myFormatter"
          >
          </el-table-column>
          <el-table-column label="時長" min-width="50">
            <template slot-scope="scope">
              約{{scope.row.answeringMinutes}}分鐘
            </template>
          </el-table-column>
          <el-table-column label="得分/總分" min-width="40">
            <template slot-scope="scope">
              {{scope.row.correctQuantity+'/'+scope.row.score}}
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot-scope="scope">
              <el-button
                  type="text" size="medium"
                  @click="navigateToResult(scope.row)"
              >
                答題記錄
              </el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getAnswerResults"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {downloadFile} from "@/utils/is-rules";
import {getStudentReport} from "@/api/report";
import {getAnswerResults} from "@/api/answerResult";
import { formatDateTime } from "@/filters";
export default {
  components: { Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
  },
  data() {
    return {
      total: 0,
      userId: null,
      listQuery: {
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        objectType: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      ruleForm: {
        students: [
          {
            id: 0,
            userNo: "",
            name: "",
            gender: null,
            school: "",
            password: "",
            gradeId: null,
          },
        ],
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
    };
  },
  created() {
    this.getAnswerResults();
  },
  methods: {
    onDownload(){
      this.getStudentReport()
    },
    navigateToResult(row) {
      const baseUrl = '/#/answer-record-detail';
      const queryParams = {
        type: 'library',
        topicId: row.topicId,
        id: row.objectId,
        gradeId: row.gradeId,
        userNo: row.userNo,
        startTime: row.startTime,
        answerResultId: row.id,
        questionListIds: row.questionListIds,
        answerValues: row.answerValues
      };
      const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');
      const fullUrl = `${baseUrl}?${queryString}`;
      window.open(fullUrl, '_blank');
    },
    getStudentReport() {
      let form = {
          nameLike: this.listQuery.nameLike || null, 
          userNoLike: this.listQuery.userNoLike || null,
        objectType: this.listQuery.objectType || null,
        parentEmailLike: this.listQuery.parentEmailLike || null,
          gender: this.listQuery.gender, 
          branchSchoolId: this.listQuery.branchSchoolId || null, 
          gradeId: this.listQuery.gradeId || null, 
          studentCodeLike: this.listQuery.studentCodeLike || null
      }
      getStudentReport(form).then((res)=>{
          downloadFile(res.data,'studentReport.xlsx')
      })
    },
    myFormatter(row, column, cellValue) {
      return cellValue ? formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm') : '';
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getAnswerResults();
    },
    onSearch() {
      this.getAnswerResults();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 10;
        }
      })
      this.getAnswerResults();
    },
    onEditorButton(id) {
      let path = `/student/${id}/edit`
      this.resolveRouter(path)
    },
    onAdd() {
      let path = `/student/add`
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/student/${id}`
      this.resolveRouter(path)
    },
    getAnswerResults() {
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        objectType: this.listQuery.objectType,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getAnswerResults(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .demo-ruleForm-div {
    margin-top: 40px;
  }
  ::v-deep {
    .cell {
      color: black;
    }
  }
}
.form-avatar {
  position: relative;
  width: 90px;
  height: 90px;
}
.search-text {
  margin-bottom: 12px;
  color: #8e8e8e;
}
.page-content {
  background-color: #fff;
}
.page-box{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.page-content-row {
  padding: 30px 10px;
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 140px;
}
.page-content-row>div:nth-last-child(1){
  min-width: 120px;
  grid-column-start: 10;
  text-align: right;
}
.page-content-row>div:nth-last-child(2){
  min-width: 120px;
}
.page-content-row>div:nth-last-child(3){
  min-width: 100px;
}
.button-el-el {
  margin-top: 30px;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}
</style>